module.exports = __webpack_public_path__ + "media/img/favicon/android-chrome-96x96-cdb59da6645897b7d62cf646ad63235e.png";